<template>
    <div class="container is-fluid">
        <loading :active.sync="isBusy"
                 :can-cancel="false"
                 :is-full-page="true"></loading>

        <Nav style="margin-bottom: 20px;" />
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-12" style="margin-top: 70px;">
                    <template>
                        <div class="level">

                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item has-text-primary">
                                    <b-icon icon="paperclip"></b-icon>
                                    <h4 class="title is-4 has-text-primary">{{ $route.name }}</h4>
                                </div>
                                <b-field>
                                    <b-radio-button v-model="isEdit" :native-value="true" type="is-success">
                                        <b-icon icon="paperclip"></b-icon>
                                        <span>Jobsite</span>
                                    </b-radio-button>
                                    <b-radio-button v-model="isEdit" :native-value="false" type="is-primary">
                                        <b-icon icon="layers"></b-icon>
                                        <span>Drive</span>
                                    </b-radio-button>
                                </b-field>
                            </div>

                            <!-- Right side -->
                            <div v-if="isEdit">
                                <div class="level-right buttons" v-if="this.tab == 0">
                                    <b-button type="is-info"
                                              @click="postJobsite()">Jobsite Create</b-button>
                                </div>
                                <div class="level-right buttons" v-if="this.tab == 1">
                                    <b-button type="is-warning"
                                              @click="putJobsite(editJobsite.id,1)">Jobsite Update</b-button>
                                </div>
                                <div class="level-right buttons" v-if="this.tab == 1">
                                    <b-button type="is-danger"
                                              @click="delJobsite(editJobsite.id)">Jobsite Delete</b-button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="level-right buttons" v-if="this.tabDriver == 0">
                                    <b-button type="is-info" @click="postWorkunit()">Drive Create</b-button>
                                </div>
                                <div class="level-right buttons" v-if="this.tabDriver == 1">
                                    <b-button type="is-warning" @click="putWorkunit()">Drive Update</b-button>
                                </div>
                                <div class="level-right buttons" v-if="this.tabDriver == 1">
                                    <b-button type="is-danger" >Drive Delete</b-button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template>
                        <div class="columns" v-if="isEdit">
                            <div class="column is-4">
                                <div class="content is-desktop">
                                    <div class="box has-background-light">
                                        <b-tabs type="is-boxed" v-model="tab" expanded>
                                            <b-tab-item label="Create" icon="newspaper">

                                                <Create @newJobsite="newJobsite = $event" />
                                            </b-tab-item>
                                            <b-tab-item label="Edit" icon="file-document-edit">
                                                <div>
                                                    <b-field label="Jobsite">
                                                        <b-select placeholder="select jobsite for edit" expanded v-model="editJobsite" :focus="changeJobSiteEdit()">
                                                            <option v-for="item in jobsitesedit" :value="item" :key="item.id">{{ item.nameJobsite }}</option>
                                                        </b-select>
                                                    </b-field>
                                                    <b-field label="Jobsite Name">
                                                        <b-input v-model="editJobsite.nameJobsite"></b-input>
                                                    </b-field>
                                                    <!--<b-field label="Jobsite Number">
                                                        <b-input type="number" v-model="editJobsite.numberJobsite"></b-input>
                                                    </b-field>-->
                                                    <b-field label="Location">
                                                        <b-input type="text" placeholder="Adreess" v-model="editJobsite.location"></b-input>
                                                    </b-field>
                                                    <b-field label="Country">
                                                        <b-select placeholder="country" expanded v-model="editJobsite.country">
                                                            <option v-for="item in country" :value="item.name" :key="item.id">{{ item.name }}</option>
                                                        </b-select>
                                                    </b-field>
                                                    <div class="columns">
                                                        <div class="column">
                                                            <b-field label="Coordinates">
                                                                <b-input placeholder="Latitude" v-model="editJobsite.coordinateLat"></b-input>
                                                            </b-field>
                                                        </div>
                                                        <div class="column">
                                                            <b-field label="-">
                                                                <b-input placeholder="Longitude" v-model="editJobsite.coordinateLng"></b-input>
                                                            </b-field>
                                                        </div>
                                                    </div>
                                                    <b-field label="Job type">
                                                        <b-select placeholder="tunnel / microtunnel / other" expanded v-model="editJobsite.type">
                                                            <option value="tunnel">Tunnel</option>
                                                            <option value="microtunnel">Microtunnel</option>
                                                            <option value="other">Other</option>
                                                        </b-select>
                                                    </b-field>
                                                    <b-field label="Jobsite condition">
                                                        <b-select placeholder="ongoing / closed" expanded v-model="editJobsite.state">
                                                            <option value="ongoing">Ongoing</option>
                                                            <option value="closed">Closed</option>
                                                            <option value="notstarted">Not started</option>
                                                            <option value="archived">Archived</option>
                                                        </b-select>
                                                    </b-field>
                                                    <b-field label="Email expedition days">
                                                        <b-select placeholder="Email expedition days" expanded v-model="editJobsite.expedition">
                                                            <option value="workingDays">Working days</option>
                                                            <!--<option value="workableDays">Workable days</option>-->
                                                            <option value="calendarDays">Calendar days</option>
                                                        </b-select>
                                                    </b-field>
                                                     <!--<b-field label="Address">
                                                        <b-input maxlength="200" type="textarea" v-model="editJobsite.adress"></b-input>
                                                    </b-field>-->
                                                </div>
                                            </b-tab-item>
                                        </b-tabs>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-8">
                                <div class="content is-medium">
                                    <div class="box padding">
                                        <div class="columns">
                                            <div class="column">
                                                <b-table :data="users"
                                                         :checked-rows.sync="selected"
                                                         :columns="columns"
                                                         paginated
                                                         checkable
                                                         ></b-table>
                                            </div>
                                            <div class="column has-background-light user-select">
                                                <template>
                                                    <h5>Selected members</h5>
                                                    <section class="user-select-body">
                                                        <div class="tags">
                                                            <span v-for="(item, index) in selected"
                                                                  :key="index"
                                                                  class="tag is-primary">
                                                                {{item.firstName}}
                                                                <button class="delete is-small"
                                                                        type="button"
                                                                        @click="deleteUserSelectd(index)"></button>
                                                            </span>
                                                        </div>
                                                    </section>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns" v-else>
                            <div class="column is-6">
                                <div class="content is-medium">
                                    <b-tabs type="is-boxed" v-model="tabDriver" expanded>
                                        <b-tab-item label="Create" icon="newspaper">
                                            <CreateWorkunits @newWorkunit="newWorkunit = $event" :isEdit="false" />
                                        </b-tab-item>
                                        <b-tab-item label="Edit" icon="file-document-edit">
                                            <CreateWorkunits @newWorkunit="newWorkunit = $event" @eventUpdateInfo="eventUpdateInfo = $event" :isEdit="true" />
                                        </b-tab-item>
                                    </b-tabs>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="content is-medium" style="margin-top: 10%;">
                                    <img class="is-background" src="../assets/sliders/bessac_bg_04_.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import axios from 'axios'

    // @ is an alias to /src
    import Nav from '@/components/Nav.vue'

    /* From Jobsite */
    import Create from '@/components/FromJobsite/Create.vue'

    /* From Workunits */
    import CreateWorkunits from '@/components/FromWorkunits/Create.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';


    export default {
        components: {
            Nav,
            Create,
            CreateWorkunits,
            Loading
        },
        data() {
            return {
                eventUpdateInfo: null,
                isBusy: false,
                tabDriver: 0,
                tab: 0,
                isEdit: true,
                jobsite: [],
                columns: [
                    {
                        field: 'firstName',
                        label: 'First Name',
                        searchable: true,
                    },
                    {
                        field: 'lastName',
                        label: 'Last Name',
                        searchable: true,
                    },
                    {
                        field: 'Roles.nameRole',
                        label: 'Role',
                        searchable: true,
                    },
                ],
                newJobsite: {
                    nameJobsite: '',
                    numberJobsite: '',
                    location: '',
                    country: '',
                    coordinateLat: '',
                    coordinateLng: '',
                    type: 'tunnel',
                    state: 'ongoing',
                    expedition: '',
                },
                jobsitesedit: [],
                idEditJobSite: 0,
                editJobsite: {},
                deleteJobsite: {
                    jobsiteId: [],
                },
                newWorkunit: {
                    id: 0,
                    jobsiteId: [],
                    nameWorkunit: '',
                    drive_number: 0,
                    pathKMZ: [],
                    pathGeojson: '',
                    diameter: '',
                    discLenght: '',
                    numberOrder: '',
                    statePathDriver: 'false',
                    comments: '',
                    inversion: false,
                    force_end_drive: false
                },
                addUserToJobsite: [],
                selected: [],
                users: []
            }
        },
        created() {
            const self = this;
            this.$store.dispatch('verifyAccess').then(() => {
                self.listJobsite();
            });
        },
        methods: {
            changeJobSiteEdit() {

                //Load Users Members
                let usersSelected = [];

                if (typeof (this.editJobsite) != 'undefined' && this.editJobsite != null && typeof (this.editJobsite.workgroup) != 'undefined') {
                    if (this.idEditJobSite != this.editJobsite.id) {
                        this.idEditJobSite = this.editJobsite.id;

                        for (let i = 0; i < this.editJobsite.workgroup.length; i++) {
                            const userId = this.editJobsite.workgroup[i].userId;
                            usersSelected.push(Object.assign(this.users.find(s => s.id == userId), {}));
                        }

                        this.selected = usersSelected;
                    }
                }
            },
            deleteUserSelectd(index) {
                this.selected.splice(index, 1)
            },
            postJobsite() {
                if (this.selected.length <= 0) {
                    this.$buefy.notification.open({
                        message: `Select at least one user.`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                    return;
                }
                this.isBusy = true;

                this.axios
                    .post('/jobsite', {
                        nameJobsite: this.newJobsite.nameJobsite,
                        numberJobsite: this.newJobsite.numberJobsite,
                        location: this.newJobsite.location,
                        country: this.newJobsite.country,
                        coordinateLat: this.newJobsite.coordinateLat,
                        coordinateLng: this.newJobsite.coordinateLng,
                        type: this.newJobsite.type,
                        state: this.newJobsite.state,
                        expedition: this.newJobsite.expedition,
                    })
                    .then(response => {

                        const genericResponse = response.data;

                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })

                            this.isBusy = false;
                            return;
                        }

                        this.sendUsers(genericResponse.result).then(() => {
                            this.$buefy.notification.open({
                                message: `New Jobsite created`,
                                position: 'is-bottom-right',
                                type: 'is-success',
                                hasIcon: true,
                            })
                        });
                    })
                    .catch(() => {
                        this.$buefy.notification.open({
                            message: `Something Goes Wrong. Try Again.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                        this.isBusy = false;
                    })
            },
            async sendUsers(newJobSite) {
                for (let i = 0; i < this.selected.length; i++) {
                    await axios
                        .post('/workgroup', {
                            userId: this.selected[i].id,
                            jobsiteId: newJobSite.id,
                        })
                }

                this.isBusy = false;
                this.clearJobsite();
                this.loadInfoJobSitesEdit();

            },
            delJobsite(id) {
                this.$buefy.dialog.confirm({
                    message: 'Confirm Delete?',
                    onConfirm: () => {
                        this.putJobsite(id, 0)
                    }
                });
            },
            putJobsite(id, isActive) {
                this.isBusy = true;
                const self = this;
                this.axios
                    .put(`/jobsite/${id}`, {
                        nameJobsite: this.editJobsite.nameJobsite,
                        numberJobsite: this.editJobsite.numberJobsite,
                        location: this.editJobsite.location,
                        country: this.editJobsite.country,
                        coordinateLat: this.editJobsite.coordinateLat,
                        coordinateLng: this.editJobsite.coordinateLng,
                        type: this.editJobsite.type,
                        state: this.editJobsite.state,
                        expedition: this.editJobsite.expedition,
                        isActive: isActive,
                        adress: this.editJobsite.adress
                    })

                    .then(() => {
                        this.axios.delete(`/workgroup/deleteWorkgroupByJobsiteId/${id}`).then(() => {
                            this.sendUsers(this.editJobsite).then(() => {
                                this.$buefy.notification.open({
                                    message: `Update Jobsite`,
                                    position: 'is-bottom-right',
                                    type: 'is-success',
                                    hasIcon: true,
                                })

                                self.idEditJobSite = 0;
                                self.editJobsite = {};
                                self.tab = 0;
                                self.loadInfoJobSitesEdit();
                                self.isBusy = false;

                            });
                        });

                    })
                    .catch(error => {
                        this.isBusy = false;
                        console.error({ error })
                        this.$buefy.notification.open({
                            message: `Something Goes Wrong. Try Again.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            clearJobsite() {
                this.newJobsite.nameJobsite = ''
                this.newJobsite.numberJobsite = ''
                this.newJobsite.location = ''
                this.newJobsite.country = ''
                this.newJobsite.coordinateLat = ''
                this.newJobsite.coordinateLng = ''
                this.newJobsite.type = 'tunnel'
                this.newJobsite.state = 'ongoing'
                this.newJobsite.expedition = ''

                this.selected = []
            },
            clearWorkunit() {
                this.newWorkunit.jobsiteId = []
                this.newWorkunit.nameWorkunit = ''
                this.newWorkunit.drive_number = 0
                this.newWorkunit.pathKMZ = []
                this.newWorkunit.pathGeojson = ''
                this.newWorkunit.diameter = ''
                this.newWorkunit.discLenght = ''
                this.newWorkunit.numberOrder = ''
                this.newWorkunit.statePathDriver = 'false'
                this.newWorkunit.inversion = false
                this.newWorkunit.comments = ''
                this.newWorkunit.force_end_drive = false
            },

            postWorkunit() {
                this.isBusy = true;

                let formData = new FormData()
                formData.append('jobsiteId', this.newWorkunit.jobsiteId.id)
                formData.append('nameWorkunit', this.newWorkunit.nameWorkunit)
                formData.append('drive_number', this.newWorkunit.drive_number)
                formData.append('pathKMZ', this.newWorkunit.pathKMZ[0])
                formData.append('diameter', this.newWorkunit.diameter)
                formData.append('discLenght', this.newWorkunit.discLenght)
                formData.append('numberOrder', this.newWorkunit.numberOrder)
                formData.append('statePathDriver', this.newWorkunit.statePathDriver)
                formData.append('comments', this.newWorkunit.comments)
                formData.append('inversion', this.newWorkunit.inversion)
                formData.append('force_end_drive', this.newWorkunit.force_end_drive)



                this.axios
                    .post('/workunit', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        const genericResponse = response.data;

                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}.`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            this.isBusy = false;
                            return;
                        }

                        this.$buefy.notification.open({
                            message: `New Drive created`,
                            position: 'is-bottom-right',
                            type: 'is-success',
                            hasIcon: true,
                        })
                        this.clearWorkunit();
                        this.loadInfoJobSitesEdit();
                        this.isBusy = false;
                        if (this.eventUpdateInfo != null) {
                            this.eventUpdateInfo();
                        }
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$buefy.notification.open({
                            message: `Error: ${error.message}.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            putWorkunit() {
                this.isBusy = true;

                let formData = new FormData()
                formData.append('jobsiteId', this.newWorkunit.jobsiteId.id)
                formData.append('nameWorkunit', this.newWorkunit.nameWorkunit)
                formData.append('drive_number', this.newWorkunit.drive_number)
                formData.append('pathKMZ', this.newWorkunit.pathKMZ.length > 0 ? this.newWorkunit.pathKMZ[0] : null)
                formData.append('diameter', this.newWorkunit.diameter)
                formData.append('discLenght', this.newWorkunit.discLenght)
                formData.append('numberOrder', this.newWorkunit.numberOrder)
                formData.append('statePathDriver', this.newWorkunit.statePathDriver)
                formData.append('comments', this.newWorkunit.comments)
                formData.append('inversion', this.newWorkunit.inversion)
                formData.append('force_end_drive', this.newWorkunit.force_end_drive)


                this.axios
                    .put(`/workunit/${this.newWorkunit.id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(response => {
                        var genericResponse = response.data;

                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}.`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            this.isBusy = false;
                            return;
                        }

                        this.$buefy.notification.open({
                            message: `Edited Drive`,
                            position: 'is-bottom-right',
                            type: 'is-success',
                            hasIcon: true,
                        })
                        //this.clearWorkunit();
                        this.loadInfoJobSitesEdit();
                        this.isBusy = false;
                        if (this.eventUpdateInfo != null) {
                            this.eventUpdateInfo();
                        }
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.$buefy.notification.open({
                            message: `Error: ${error.message}.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            },
            listJobsite() {
                this.axios
                    .get('/jobsite')
                    .then(res => {
                        this.jobsite = res.data.data
                    })
                    .catch(e => {
                        console.error('error' + e)
                    })
            },
            loadInfoJobSitesEdit() {
                this.axios
                    .get('/jobsite/getJobsitesSelect')
                    .then(response => {
                        var genericResponse = response.data;
                        if (genericResponse.isError) {
                            this.$buefy.notification.open({
                                message: `Error: ${genericResponse.messageError}`,
                                position: 'is-bottom-right',
                                type: 'is-danger',
                                hasIcon: true,
                            })
                            return;
                        }

                        this.jobsitesedit = genericResponse.result;

                    })
                    .catch(error => {
                        this.$buefy.notification.open({
                            message: `Error: ${error.message}.`,
                            position: 'is-bottom-right',
                            type: 'is-danger',
                            hasIcon: true,
                        })
                    })
            }
        },
        mounted() {
            this.isBusy = true;
            this.$store.dispatch('getUser').then(response => {
                const genericResponse = response.data;
                if (genericResponse.isError == true) {
                    this.$buefy.notification.open({
                        message: `Error: ${genericResponse.messageError}`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true,
                    })
                    this.isBusy = false;
                    return;
                }

                this.isBusy = false;
                this.users = genericResponse.result;
                this.loadInfoJobSitesEdit();

            }).catch(err => {
                this.$buefy.notification.open({
                    message: `Error: ${err.message}`,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true,
                })
                this.isBusy = false;
            });
        },
        computed: {
            ...mapState(['country']),
        }
    }
</script>
<style lang="scss">

    .user-select {
        margin: -8px -8px -8px 0;
        height: 74vh;
        &-body

    {
        height: 66vh;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        background: #fff;
        padding: 16px;
    }

    }

    .map {
        height: 80vh;
        border-radius: 6px;
        z-index: 5;
    }

    .content ul {
        list-style: none;
        margin-left: 0;
        margin-top: 0;
    }

    .content li + li {
        margin-top: 0;
    }
</style>

